/*
    Action:     Draws a dropdown module
    Orginator:  ben.hobden@espn.com
*/

var React               = require('react');
var classNames          = require('classnames');
var Link                = require('react-router').Link;

var DropDown = React.createClass({

    getInitialState: function(){
        return {
            open: false,
            name: ''
        };
    },

    /* is the a replacement for espn_ui.Behaviors.button_dropdown */
    onMouseLeave : function(e){
        // Hides the <ul>, else an empty rectangle appears below the dropdown button
        this.refs.ul.getDOMNode().setAttribute('style', 'display:none');
        this.setState({open:false});
    },

    onMouseEnter : function(e){
        this._removeStyleAttr();
        this.setState({open:true});
    },
    
    /**
     * Removes the style attr from the <ul>
     * so that the show-dropdown class gets applied
     */
    _removeStyleAttr: function(){
        var ul = this.refs.ul.getDOMNode();
        if(ul.getAttribute('style') !== null){
            ul.removeAttribute('style');
        }
    },

    onClick: function(e){
        this.refs.ul.getDOMNode().setAttribute('style', 'display:none');
        this.setState({
            name: e.currentTarget.textContent || e.currentTarget.innerText,
            open: false
        });
    },
    
    componentDidMount: function() {
        var self = this;
        try{
            /**
             * If the blur event does not trigger,
             * switch to the closed state
             */
            $('.scoreboards').on('click', function(){
                var ul = self.refs.ul.getDOMNode();
                if(!$(ul).is(':visible')){
                    self.setState({
                        open: false
                    });
                }
            });
        }catch(e){}
    },
    
    componentDidUpdate: function(prevProps, prevState) {
        // At times the 'show-dropdown' class doesn't get applied to the DOM
        // so re-adding it back on component update
        // TODO: Fix the root issue
        if(this.state.open){
            var div = this.refs.div;
            div.getDOMNode().setAttribute('class', div.props.className);
        }
    },

    render: function(){

        var aItems          = this.props.items || [];
        var sDDName         = this.state.name || this.props.name;
        var bAutoWidth      = this.props.autoWidth || false;
        var bDropLeft       = this.props.dropLeft || false;
        var bMobileOnly     = this.props.mobileOnly || false;

        /* Check items are an array */
        if(Object.prototype.toString.call(aItems) !== '[object Array]' ) {
            /* log error? */
            return null;
        }

        var iItemsLength    = aItems.length;
        var i               = 0;
        var aListItems      = [];
        var aDDClasses      = ['dropdown-wrapper'];
        var sDDULClasses    = ['dropdown-menu','med'];

        for (i = 0; i < iItemsLength; ++i){

            var oItem       = aItems[i];
            var sUrl        = oItem.url || '#';
            var sName       = oItem.name || '-';
            var sTrackLink  = oItem.trackLink || '';
            var bReactURL   = oItem.reactURL || false;
            var bExternal   = oItem.external || false;

            var props       = {
                itemProp:   'url',
                to:         sUrl,
                href:       sUrl,
                target:     '_top'
            };

            /* Need to convert this */
            //call util.trackLink(trackParams)
            props.name = sTrackLink;

            if(bExternal){
                target.name = '_newWin';
            }

            if(bReactURL){
                props['data-route'] = 'false';
                aListItems.push((
    	   			<li key={i} onClick={this.onClick}>
    	   				<Link {...props}>
    	   				    {sName}
    	   				</Link>
    	   			</li>
    	   		));
            }else{
                aListItems.push((
    	   			<li key={i} onClick={this.onClick}>
    	   				<a {...props}>
    	   				    {sName}
    	   				</a>
    	   			</li>
    	   		));
            }
        }

        if(bAutoWidth){
            aDDClasses.push('width-auto');
        }

        if(bMobileOnly){
            aDDClasses.push('mobile-only');
        }

        if(bDropLeft){
            sDDULClasses.push('drop-left');
        }

        if(this.state.open){
            aDDClasses.push('show-dropdown');
        }

        var divProps = {
            ref: "div",
            onMouseLeave : this.onMouseLeave,
            style: { display : 'inline-block', position : 'relative' },
            className:          classNames(aDDClasses),
            //'data-behavior':    'button_dropdown' /* NOT required as i'll let react deal with this */
        };
        
        if(this.props.id){
            divProps.id = this.props.id;
        }

        return (
        	<div {...divProps} onMouseLeave={this.onMouseLeave} onMouseEnter={this.onMouseEnter}>
        		<button className="button-filter med dropdown-toggle" type="button" onTouchStart={this.onMouseEnter}>{sDDName}</button>
        		<ul ref="ul" className={classNames(sDDULClasses)} role="menu">
        		    {aListItems}
        		</ul>
        	</div>
        );
    }
});

module.exports = DropDown;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/dropdown.jsx
 **/